import React from 'react';
import ReactMarkdown from 'react-markdown';
import { IMAGE_STYLES } from '../../constants/constants';

const SectionCard = ({ section }) => {
  // Function to properly format markdown text by replacing escaped newlines
  const formatMarkdown = (text) => {
    if (!text) return '';
    // Replace escaped newlines with actual newlines
    return text.replace(/\\n/g, '\n');
  };

  // Separate text-based and image-based outcomes
  const textOutcomes = section.learningOutcomes?.filter(outcome => outcome.resultType !== 'image') || [];
  const imageOutcomes = section.learningOutcomes?.filter(outcome => outcome.resultType === 'image') || [];
  
  return (
    <div className="my-4 section-card ">
      <div className="page-item">
        <div className="flex items-center gap-2 mb-2">
          <span className="inline-block w-2 h-2 rounded-full bg-emerald-400"></span>
          <h3 className="text-lg font-bold text-gray-800">{section.title}</h3>
        </div>
        
        {section.objective && (
          <div className="mb-2 mx-3 text-gray-600 italic text-sm">{section.objective}</div>
        )}
        
        {section.aiSummary && (
          <div className="mb-3 p-6 bg-gray-50 rounded-lg border border-gray-200 shadow-sm">
            <div className="flex items-center gap-2 mb-1">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-purple-600" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
              </svg>
              <h4 className="text-sm font-semibold text-purple-800">Progress Summary</h4>
            </div>
            <div className="text-sm text-gray-700 prose prose-sm max-w-none">
              <div className="markdown-content" style={{ lineHeight: "2" }}>
                <ReactMarkdown>{formatMarkdown(section.aiSummary)}</ReactMarkdown>
              </div>
            </div>
          </div>
        )}
      </div>
      
      {/* Tabular structure for text-based outcomes */}
      {}
      {textOutcomes.length > 0 && (
        <div className="overflow-hidden rounded-lg border border-gray-200 shadow-sm mb-4 page-item">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Learning Outcome
                </th>
                <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Result
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {textOutcomes.map((outcome, index) => (
                <tr key={outcome.id || outcome.label || index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                  <td className="px-4 py-2 text-sm text-gray-800 font-medium">
                    {outcome.label}
                  </td>
                  <td className="px-4 py-2">
                    <span className={`inline-block px-2 py-1 rounded-full text-xs font-medium ${
                      outcome.result === 'Developing' ? 'bg-yellow-100 text-yellow-800' :
                      outcome.result === 'Emerging' ? 'bg-orange-100 text-orange-800' :
                      'bg-gray-100 text-gray-700'
                    }`}>
                      {outcome.result}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

        </div>
      )}
      
      {/* Grid layout for image-based outcomes */}
      {/* {imageOutcomes.length > 0 && (
        <div 
          data-key="image-key" 
          className="mt-4 page-item" 
          style={{ height: '110px' }}
        >
        </div>
      )} */}
      {imageOutcomes.length > 0 && (
        <div data-key="image-key" className="mt-4 page-item">
          {imageOutcomes.length > 0 && (
            <h4 className="text-sm font-medium text-gray-700 mb-2">Visual Assessments</h4>
          )}
          <div className="grid grid-cols-1 gap-4">
            {imageOutcomes.map((outcome, index) => (
              <div key={outcome.id || outcome.label || index} className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm">
                <h5 className="font-medium text-gray-800 mb-2">{outcome.label}</h5>
                <div className="flex justify-center">
                  <img 
                    src={outcome.result} 
                    alt={outcome.label} 
                    className="max-w-full h-auto object-contain rounded" 
                    style={{ maxHeight: `${IMAGE_STYLES.MAX_HEIGHT}px` }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Section divider - professional looking separator for PDF documents */}
      <div className="mt-6 mb-2 page-item">
        <div className="flex items-center justify-center">
          <div className="flex-grow border-t border-gray-300"></div>
          <div className="mx-4">
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              className="h-4 w-4 text-gray-300" 
              fill="currentColor" 
              viewBox="0 0 24 24"
            >
              <circle cx="12" cy="12" r="4" />
            </svg>
          </div>
          <div className="flex-grow border-t border-gray-300"></div>
        </div>
      </div>
    </div>
  );
};

export default SectionCard; 